import importAgileList from "@/views/agileImport/importAgileList.vue"; //agile列表导入
import importAgileClass from "@/views/agileImport/importAgileClass.vue"; //agile Class导入
export const TestPage = [
  {
    path: "/riskReport",
    component: () => import("@/views/test/test.vue"),
    meta: { comp: "RiskReport" },
  },
  {
    path: "/questionManageReport",
    component: () => import("@/views/test/test.vue"),
    meta: { comp: "ManageReport" },
  },
  {
    path: "/projectGlobalView",
    component: () => import("@/views/test/test.vue"),
    meta: { comp: "GlobalView" },
  },
  {
    path: "/projectChartView",
    component: () => import("@/views/test/test.vue"),
    meta: { comp: "EChartView" },
  },
  // {
  //   path: "/importAgileList",
  //   component: importAgileList,
  // },
  // {
  //   path: "/importAgileClass",
  //   component: importAgileClass,
  // },
];
